// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__3JXUj","name":"UserMenu_name__3DVRV","button":"UserMenu_button__2jAoZ"};